import { useMemo } from 'react';
import {
  CATEGORY_ISSUES_MODEL,
  CATEGORY_ISSUES_TABLE_MODEL
} from './category.issues.model';
import { StyledCell } from '../../../../../ResourceAllocationOverview/JiraStats/useTableRows/Row.style';
import KeyCell from '../../../../../ResourceAllocationOverview/JiraStats/useTableRows/cell-components/KeyCell';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { PM_PROVIDERS } from 'common/constants/constants';
import IssueTypeCell from './cells/IssueTypeCell';

const useRows = ({ issues }) => {
  const pmProvider = usePmProvider();

  const rows = useMemo(() => {
    return issues.map(issue => {
      const key = issue?.[CATEGORY_ISSUES_MODEL.KEY];
      const title = issue?.[CATEGORY_ISSUES_MODEL.TITLE] ?? 'N/A';
      const url = issue?.[CATEGORY_ISSUES_MODEL.URL];
      const assignee = issue?.[CATEGORY_ISSUES_MODEL.ASSIGNEE];
      const typeName = issue?.[CATEGORY_ISSUES_MODEL.TYPE.NAME];
      const typeIconUrl = issue?.[CATEGORY_ISSUES_MODEL.TYPE.ICON];

      return {
        [CATEGORY_ISSUES_TABLE_MODEL.TYPE_CELL]: (
          <IssueTypeCell name={typeName} icon={typeIconUrl} />
        ),
        ...(pmProvider === PM_PROVIDERS.JIRA && {
          [CATEGORY_ISSUES_TABLE_MODEL.KEY_CELL]: (
            <KeyCell title={key} url={url} />
          )
        }),
        [CATEGORY_ISSUES_TABLE_MODEL.TITLE_CELL]: (
          <KeyCell
            title={title}
            url={pmProvider === PM_PROVIDERS.AZURE_BOARDS && url}
          />
        ),
        [CATEGORY_ISSUES_TABLE_MODEL.ASSIGNEE_CELL]: (
          <StyledCell>{assignee?.name}</StyledCell>
        )
      };
    });
  }, [issues]);

  return rows;
};

export default useRows;
